import { Form, Button, Row, Col } from "react-bootstrap";
import { useState } from "react";

export default function CategoryForm({ onCreate }) {
  const [name, setName] = useState("");

  const submit = () => {
    if (!name.trim()) return;
    onCreate(name);
    setName("");
  };

  return (
    <Row className="mb-3">
      <Col>
        <Form.Control
          placeholder="New category name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </Col>
      <Col xs="auto">
        <Button onClick={submit}>Add</Button>
      </Col>
    </Row>
  );
}
